import useContentBuild from './use-content-build';

export default useContentBuild;
